export default "__VITE_ASSET__BaJ3Zww2__"